<div
  [attr.data-test]="dataTest()"
  [attr.title]="ariaTitle() | translate"
  [attr.ngbAutofocus]="hasAutoFocus() ? true : null"
  (click)="!disabled() && cardClicked.emit()"
  (keydown.enter)="!disabled() && cardClicked.emit()"
  [class]="'card-basic h-100 p-0' + (disabled() ? ' card-disabled' : ' card-clickable')"
  [attr.tabindex]="disabled() ? -1 : 0"
  [attr.aria-disabled]="disabled()"
>
  <div class="card-basic-body">
    <div class="row h-100 g-2">
      <div class="col">
        <div class="mb-1">
          <mwe-product-icons
            [categories]="categories()"
            [categoryTranslationKeys]="categoryTranslationKeys()"
            [size]="'xl'"
            [textNodeType]="textNodeType()"
          />
        </div>
        <ng-content />
      </div>
      <div class="col-auto align-self-center">
        <i class="fas fa-chevron-right text-body"></i>
      </div>
    </div>
  </div>
</div>
